import gql from 'graphql-tag'

export default gql`
    query AvailableHouseNumbers($zipcode: String!, $city: String!, $street: String!, $district: String) {
        availableHouseNumbers(zipcode: $zipcode, city: $city, street: $street, district: $district)
    }
`
